"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UniqueComponentVerifier = _interopRequireDefault(require("./utility/UniqueComponentVerifier"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var COMPONENT_TAG = 'ikea-component';
/**
 * IKEA Component Manager.
 */

var ComponentManager = /*#__PURE__*/function () {
  /**
   * Renders the component.
   *
   * @param {Element} [context] Context element to run the manager in. Default is the "document" element.
   */
  function ComponentManager() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document.documentElement;

    _classCallCheck(this, ComponentManager);

    this.context = context; // Context element

    this.useComponentObservers = true; // TRUE to enable observers in components

    this.filterElements = null; // If defined as an Array, only the element inside the Array are allowed

    this.componentClasses = new Map();
    this._componentElements = null;
    this._components = new Map();
    this._observerUpdateTimeout = null;
    this._observer = null;
  }
  /**
   * Returns all components by component class type.
   *
   * @param {Class} componentClass AbstractComponent class.
   * @param {Boolean} [traverse] Set to TRUE to traverse trough sub ComponentManagers in child components. Default is FALSE.
   * @return {AbstractComponent[]} Array of AbstractComponent instances.
   */


  _createClass(ComponentManager, [{
    key: "findAll",
    value: function findAll(componentClass) {
      var traverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var returnValue = [];

      var _iterator = _createForOfIteratorHelper(this._components.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var component = _step.value;

          if (component.constructor.componentName === componentClass.componentName) {
            returnValue.push(component);
          }

          if (traverse) {
            returnValue = returnValue.concat(component.dom.componentManager.findAll(componentClass, traverse));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return returnValue;
    }
    /**
     * Gets the first component by component class.
     *
     * @param {Class} componentClass AbstractComponent class.
     * @param {Boolean} [traverse] Set to TRUE to traverse trough sub ComponentManagers in child components. Default is FALSE.
     * @return {AbstractComponent|Null} AbstractComponent instances or null.
     */

  }, {
    key: "findFirst",
    value: function findFirst(componentClass) {
      var traverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _iterator2 = _createForOfIteratorHelper(this._components.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var component = _step2.value;

          if (component instanceof componentClass) {
            return component;
          }

          if (traverse) {
            var childComponent = component.dom.componentManager.findFirst(componentClass, traverse);

            if (childComponent) {
              return childComponent;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return null;
    }
    /**
     * Returns the first component that matches an Element.
     *
     * @param {Element} element DOM Element.
     * @param {Class} componentClass AbstractComponent class.
     * @return {AbstractComponent|Null} AbstractComponent instances or null.
     */

  }, {
    key: "findFirstInsideElement",
    value: function findFirstInsideElement(element, componentClass) {
      var componentElement = element.querySelector(COMPONENT_TAG + '[name="' + componentClass.componentName + '"]');
      return componentElement ? this.getByElement(componentElement) : null;
    }
    /**
     * Returns the first component that matches an Element.
     *
     * @param {Element} element DOM Element.
     * @param {Class} componentClass AbstractComponent class.
     * @return {AbstractComponent[]} Array of AbstractComponent instances.
     */

  }, {
    key: "findAllInsideElement",
    value: function findAllInsideElement(element, componentClass) {
      var componentElements = element.querySelectorAll(COMPONENT_TAG + '[name="' + componentClass.componentName + '"]');
      var componentInstances = [];

      for (var i = 0, max = componentElements.length; i < max; i++) {
        var component = this.getByElement(componentElements[i]);

        if (component) {
          componentInstances.push(component);
        }
      }

      return componentInstances;
    }
    /**
     * Returns the first component that matches an Element.
     *
     * @param {Element} element DOM Element.
     * @return {AbstractComponent|Null} AbstractComponent instances or null.
     */

  }, {
    key: "getByElement",
    value: function getByElement(element) {
      return this._components.get(element) || null;
    }
    /**
     * Registers a component class.
     *
     * @param {Function} componentClass AbstractComponent class.
     */

  }, {
    key: "register",
    value: function register(componentClass) {
      this.componentClasses.set(componentClass.componentName, componentClass);

      _UniqueComponentVerifier.default.register(componentClass);
    }
    /**
     * Registers multiple component classes.
     *
     * @param {Function[]} componentClasses AbstractComponent classes.
     */

  }, {
    key: "registerMany",
    value: function registerMany(componentClasses) {
      var _iterator3 = _createForOfIteratorHelper(componentClasses),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var componentClass = _step3.value;
          this.register(componentClass);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    /**
     * Checks for component changes in DOM.
     *
     * @param {Boolean} [updateProps] TRUE to check for prop changes. Default is FALSE.
     * @param {Boolean} [forceRender] TRUE to force rendering of components after prop has been updated. Default is FALSE.
     * @return {AbstractComponent[]} Rendered components.
     */

  }, {
    key: "update",
    value: function update() {
      var updateProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var forceRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var renderedComponents = this._renderComponents(updateProps, forceRender);

      this._handleRemovedComponents();

      return renderedComponents;
    }
    /**
     * Destroys all components, disconnects the mutation observer and resets state.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.disconnectObserver();

      var _iterator4 = _createForOfIteratorHelper(this._components.values()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var component = _step4.value;
          this.removeComponent(component);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      this.filterElements = null;
      this.componentClasses = new Map();
      this._componentElements = null;
    }
    /**
     * Adds a component.
     *
     * @param {Element} element "ikea-component" element.
     * @return {AbstractComponent|Null} Component instance.
     */

  }, {
    key: "addComponent",
    value: function addComponent(element) {
      var componentClass = this.componentClasses.get(element.getAttribute('name'));

      if (componentClass && element.getAttribute('data-rendered') === null && this._components.get(element) === undefined) {
        var component = new componentClass(element);
        component.attributeObserver.enabled = this.useComponentObservers;
        component.body.useObserver = this.useComponentObservers;
        element.setAttribute('data-rendered', 'false');

        this._components.set(element, component);

        return component;
      }

      return null;
    }
    /**
     * Removes a component.
     *
     * @param {AbstractComponent} component Component instance.
     */

  }, {
    key: "removeComponent",
    value: function removeComponent(component) {
      this._components.delete(component.element);

      component.destroyAll();
    }
    /**
     * Adds or updates a component.
     *
     * @param {Element} element Component element.
     * @param {Boolean} [updateProps] TRUE to check for prop changes. Default is FALSE.
     * @param {Boolean} [forceRender] TRUE to force rendering of components after prop has been updated. Default is FALSE.
     * @return {AbstractComponent|Null} Rendered component.
     */

  }, {
    key: "renderComponent",
    value: function renderComponent(element) {
      var updateProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var forceRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (element.parentNode) {
        var createdComponent = this.addComponent(element);

        if (createdComponent !== null) {
          createdComponent.render();
          return createdComponent;
        } else if (updateProps) {
          var component = this.getByElement(element);

          if (component) {
            if (!component.isDestroyed && !component.propHandler.hasChangedComponentName()) {
              var isBodyChanged = component.$mutations && component.$mutations.length > 0;

              if (component.updateProps() || isBodyChanged || forceRender) {
                if (isBodyChanged) {
                  component.body.trigger('change', component.$mutations);
                  delete component.$mutations;
                }

                component.render();
              }

              return component;
            } else {
              this.removeComponent(component);
              var changedComponent = this.addComponent(element);
              changedComponent.render();
              return changedComponent;
            }
          }
        }
      }

      return null;
    }
    /**
     * Connects observer.
     */

  }, {
    key: "connectObserver",
    value: function connectObserver() {
      var _this = this;

      if (this._observer === null) {
        this._observer = new MutationObserver(function () {
          clearTimeout(_this._observerUpdateTimeout);
          _this._observerUpdateTimeout = setTimeout(_this.update.bind(_this));
        });

        this._observer.observe(this.context, {
          attributes: false,
          childList: true,
          characterData: false,
          subtree: true
        });

        this.update();
      }
    }
    /**
     * Disconnects observer.
     */

  }, {
    key: "disconnectObserver",
    value: function disconnectObserver() {
      if (this._observer !== null) {
        clearTimeout(this._observerUpdateTimeout);

        this._observer.disconnect();

        this._observer = null;
      }
    }
    /**
     * Checks for removes components.
     */

  }, {
    key: "_handleRemovedComponents",
    value: function _handleRemovedComponents() {
      var _iterator5 = _createForOfIteratorHelper(this._components.values()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var component = _step5.value;
          var hasChangedName = component.element.getAttribute('name') !== component.constructor.componentName;

          if (!this.context.contains(component.element) && !window.document.body.contains(component.element) || hasChangedName) {
            this.removeComponent(component);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
    /**
     * Checks for existing components.
     *
     * @param {Boolean} [updateProps] TRUE to check for prop changes. Default is FALSE.
     * @param {Boolean} [forceRender] TRUE to force rendering of components after prop has been updated. Default is FALSE.
     * @return {AbstractComponent[]} Rendered components.
     */

  }, {
    key: "_renderComponents",
    value: function _renderComponents() {
      var updateProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var forceRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var renderedComponents = [];
      var componentElements = this.filterElements ? this.filterElements : this._getComponentElements();

      for (var i = 0, max = componentElements.length; i < max; i++) {
        var renderedComponent = this.renderComponent(componentElements[i], updateProps, forceRender);

        if (renderedComponent) {
          renderedComponents.push(renderedComponent);
        }
      }

      return renderedComponents;
    }
    /**
     * Returns the current component elements.
     *
     * @return {Element[]} Array of component elements.
     */

  }, {
    key: "_getComponentElements",
    value: function _getComponentElements() {
      this._componentElements = this._componentElements || this.context.getElementsByTagName(COMPONENT_TAG);
      return Array.from(this._componentElements);
    }
  }]);

  return ComponentManager;
}();

exports.default = ComponentManager;